












import { Component, Prop, Vue } from 'vue-property-decorator'
import { Project } from '@shared/types/database'
import { Icon, Select } from '@alpha/ink'
import EditMetaDataModal, { SelectOption } from '@/components/TestDetails/EditMetaDataModal.vue'
import store from '@/store'

export interface EditProjectPayload {
  project: Project,
  follow: boolean
}

@Component({
  components: {
    Select,
    Icon,
    EditMetaDataModal
  }
})
export default class EditProjects extends Vue {
  @Prop({ required: true }) readonly associatedProjects!: Project[]

  get allProjects () {
    return Object.values(store.state.workspace.projectMap)
      .filter(p => p.title && (p.id || p.uid))
      .map(project => {
        // project.uid is deprecated and is a number
        if (!project.id && project.uid) project.id = project.uid.toString()
        return project
      })
  }

  get dissociatedProjectOptions (): SelectOption[] {
    const dissociatedProjects = this.allProjects
      .filter(commonProject => {
        // Some legacy projects are missing basic info, maybe we should filter these server side
        if (!commonProject.title || !commonProject.id) return false

        return !this.associatedProjects.find(alreadyIncludedProject => {
          const haveSameId = commonProject.id === alreadyIncludedProject.id
          const haveSameUID = commonProject.uid && alreadyIncludedProject.uid && commonProject.uid === alreadyIncludedProject.uid
          return haveSameId || haveSameUID
        })
      })

    return dissociatedProjects.map(this.projectToSelectOption)
  }

  get associatedProjectOptions (): SelectOption[] {
    return this.associatedProjects.map(this.projectToSelectOption)
  }

  projectToSelectOption (project: Project): SelectOption {
    return ({
      label: project.title,
      id: project.id
    })
  }

  associateProject (optionValue: string) {
    const project = this.allProjects.find(project => project.id === optionValue)
    this.$emit('edit-project', {
      project,
      follow: true
    })
  }

  dissociateProject (optionValue: string) {
    const project = this.allProjects.find(project => project.id === optionValue)
    this.$emit('edit-project', {
      project,
      follow: false
    })
  }
}

